module.exports = __webpack_public_path__ + "img/zsg-01.9ceea187.png";